export default __webpack_public_path__ + "static/media/team-3.e540e86b.png";